import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var BoletoUrls = function BoletoUrls(_ref) {
  var order = _ref.order;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (order.pendingPayments || []).filter(function (pendingPayment) {
    return pendingPayment.boletoUrl;
  }).map(function (pendingPayment) {
    return /*#__PURE__*/React.createElement("a", {
      "aria-label": t('download boleto'),
      className: "action-link d-block",
      href: pendingPayment.boletoUrl,
      key: pendingPayment.boletoUrl
    }, /*#__PURE__*/React.createElement(T, {
      source: "download boleto"
    }));
  }));
};
export default BoletoUrls;